import { render, staticRenderFns } from "./TagTableHeader.vue?vue&type=template&id=04b415dd&scoped=true"
import script from "./TagTableHeader.vue?vue&type=script&lang=js"
export * from "./TagTableHeader.vue?vue&type=script&lang=js"
import style0 from "./TagTableHeader.vue?vue&type=style&index=0&id=04b415dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b415dd",
  null
  
)

export default component.exports